import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConstants } from '../common/constants';
import { ICompany, IApplication } from '../models';
import { BaseResponse, IResponse } from '../models/responses';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {



  constructor(private httpClient: HttpClient) { }

  GetCompanies(): Observable<IResponse<ICompany[]>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/Company/GetCompanies`;

    return this.httpClient.get<IResponse<ICompany[]>>(url, { headers });
  }

  GetCompany(_id: number): Observable<IResponse<ICompany>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/Company/GetCompany?id=${_id}`;

    return this.httpClient.get<IResponse<ICompany>>(url, { headers });
  }

  CreateCompany(_company: ICompany): Observable<BaseResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/Company/CreateCompany`;

    return this.httpClient.post<BaseResponse>(url, _company, { headers });
  }

  UpdateCompany(_company: ICompany): Observable<BaseResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/Company/UpdateCompany`;

    return this.httpClient.post<BaseResponse>(url, _company, { headers });
  }

  GetCompanyApplications(_companyId: number): Observable<IResponse<IApplication[]>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/Company/GetApplicationsByCompany?id=${_companyId}`;

    return this.httpClient.get<IResponse<IApplication[]>>(url, { headers });
  }

  //-----------------------------------------001
  UpdateApplication(app: IApplication): Observable<BaseResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/Company/UpdateApplication`;

    return this.httpClient.post<BaseResponse>(url, app, { headers });
  }

  CreateApplication(_app: IApplication): Observable<BaseResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/Company/CreateApplication`;

    return this.httpClient.post<BaseResponse>(url, _app, { headers });
  }
}
